import { Box } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  LabelList,
  ResponsiveContainer,
} from "recharts";

// Custom progress capsule shape component (draws background full capsule + partial fill)
const CapsuleProgress = (props) => {
  const { x, y, width, height, fill, value = 0 } = props;
  const r = width / 2;
  const left = x;
  const right = x + width;
  const delta = height * (100 / value - 1);
  const fullTop = y - delta;
  const fullBottom = y + height;

  // Full capsule background path
  const bgPath = `
    M ${left} ${fullTop + r}
    A ${r} ${r} 0 0 1 ${left + r} ${fullTop}
    L ${right - r} ${fullTop}
    A ${r} ${r} 0 0 1 ${right} ${fullTop + r}
    L ${right} ${fullBottom - r}
    A ${r} ${r} 0 0 1 ${right - r} ${fullBottom}
    L ${left + r} ${fullBottom}
    A ${r} ${r} 0 0 1 ${left} ${fullBottom - r}
    L ${left} ${fullTop + r}
    Z
  `;

  // Partial or full fill path
  let fillPath;
  if (value >= 99.5) {
    fillPath = bgPath;
  } else {
    const fillTop = y;
    const fillBottom = fullBottom;
    fillPath = `
      M ${left} ${fillTop}
      L ${right} ${fillTop}
      L ${right} ${fillBottom - r}
      A ${r} ${r} 0 0 1 ${right - r} ${fillBottom}
      L ${left + r} ${fillBottom}
      A ${r} ${r} 0 0 1 ${left} ${fillBottom - r}
      L ${left} ${fillTop}
      Z
    `;
  }

  return (
    <g>
      <path d={bgPath} fill="#fff" stroke="rgba(103, 60, 142, 1)" strokeWidth="2" />
      {height > 1 && (
        <path d={fillPath} fill={fill} />
      )}
    </g>
  );
};

// Custom label positioned above the full capsule top
const CustomLabel = (props) => {
  const { x, y, width, height, value = 0 } = props;
  const delta = height * (100 / value - 1);
  const fullTop = y - delta;
  const displayValue = Math.round(value);
  return (
    <text
      x={x + width / 2}
      y={fullTop - 8}
      textAnchor="middle"
      fontSize="11px"
      fontWeight="bold"
      fill="rgba(103, 60, 142, 1)"
    >
      {`${displayValue}%`}
    </text>
  );
};

const DriversBarChart = ({ data = [] }) => {
  // Transform API data -> match chart keys
  const chartData = data.map((item) => ({
    name: item.day,
    performance: item.percent === 0 ? 0.01 : item.percent,
  }));

  return (
    <Box width="100%" height={160}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} barCategoryGap={20} margin={{ top: 20 }}>
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{
              fontSize: "11px",
              fontWeight: 400,
              fill: "rgba(103, 60, 142, 1)",
            }}
          />
          <YAxis domain={[0, 100]} hide />
          <Bar
            dataKey="performance"
            fill="rgba(103, 60, 142, 1)"
            shape={<CapsuleProgress />}
            barSize={30}
          >
            <LabelList dataKey="performance" content={<CustomLabel />} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default DriversBarChart;